<app-svg [src]="src()" size="0-5"></app-svg>
